module.exports = __webpack_public_path__ + "viasat-golf-423140338ffb1fd7a4233d132c6bfa34.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/viasat-golf.jpg
// module id = 1156
// module chunks = 0 1